// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"7744ebb8","83":"0c0b4b1b","233":"126bf188","660":"f3b8a700","697":"88dfe236","774":"e535cbc7","823":"0ca2e9f2","842":"219ff32d","957":"5a97e09d"}[chunkId] + ".chunk.js";
};